export default "__VITE_ASSET__4e4SntDx__"